module.exports = __webpack_public_path__ + "static/media/defaultClassPic.ee0908ae.png";